import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core";
import { theme } from "../../theme/theme";

export const styles = ({ spacing }: Theme) => createStyles({
    container: {
        marginTop: (spacing.unit * 10),
        marginBottom: (spacing.unit * 10),
        marginRight: spacing.unit * 4,
        marginLeft: spacing.unit * 4,
        width: `calc(100% - ${theme.spacing.unit * 8}px)`
    },

    product : {
        display:  "flex",
        margin: spacing.unit * 1.5
    }

});


// WEBPACK FOOTER //
// ./src/components/Products/Products.style.tsx